import React, { useState } from "react";
import "./NewsletterBlock.css";
import SocialMediaLinks from "../../SocialMediaLinks/SocialMediaLinks";
import { API_BASE } from "../../../api/client";

const NewsletterBlock = (props) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const p = props?.props || {};
  const title = p.title || "Subscribe to our newsletter";
  const subtitle = p.subtitle || "New arrivals, rental offers and style tips—right to your inbox.";
  const placeholder = p.placeholder || "YOUR EMAIL ADDRESS";
  const buttonText = p.buttonText || "Sign up";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setError("");
    setSuccess("");
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Could not subscribe.");
      setSuccess(data.message || "Subscribed! Check your inbox.");
      setEmail("");
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="newsletterBlock">
      <div className="newsletterBlockInner">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        {success ? (
          <p className="newsletterSuccess" role="status">{success}</p>
        ) : (
          <form onSubmit={handleSubmit} className="newsletterForm">
            <input
              type="email"
              placeholder={placeholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={submitting}
            />
            <button type="submit" disabled={submitting}>
              {submitting ? "…" : buttonText}
            </button>
          </form>
        )}
        {error && <p className="newsletterError" role="alert">{error}</p>}
        <SocialMediaLinks className="newsletterSocial" />
      </div>
    </section>
  );
};

export default NewsletterBlock;
